import React from 'react';
import moment from 'moment';

import { DatePicker } from '@fluentui/react';

import * as QA from 'shared/utils/queryAnalysis'
import * as DT from './dateTimeUtils';



export function DateField(props) {
  return (
    <DT.WithPicker
      component={DateFieldBase}
      componentProps={props}
      converterProps={{ formatString: DT.Format.Date, errorString: DT.Errors.Date }}      
    />
  );
}


export function DateFieldBase({ value /* moment */, substitution, error = '', disabled, onChange }) {
  function handleFormatDate(jsDate) {
    return substitution; 
  }

  return (
    <DatePicker
      placeholder={'Select Date'}
      showMonthPickerAsOverlay={true}
      value={substitution ? new Date(Date.now()) : (value.isValid() ? value.toDate() : moment().toDate())} // use fake to to make control happy
      formatDate={substitution ? handleFormatDate : undefined}
      onSelectDate={(jsDate) => onChange(DT.jsDateToMoment(jsDate))}
      styles={{ root: { width: '100%'} }}
      disabled={disabled}
    />
  );
}


export default DateField;